import { useContext } from 'react';
import { LanguageOption } from './LanguageOption';
import { SpecificLocalizationContext } from './SpecificLocalizationContext';

export function useCurrentLanguage(): LanguageOption {
	const context = useContext(SpecificLocalizationContext);
	return context.language;
}
